import React from 'react';
import { connect } from 'react-redux';
import { Mixpanel } from '../../redux/Mixpanel';

import store from '../../redux/store';
import { fetchPropertiesUnitsTenants } from '../../redux/middleware/properties';
import {
    fetchTeam, showLoading, deleteTeamMember,
    showCustomError, fetchUser
} from '../../redux/actions';
import _ from 'lodash';
import { withRouter } from 'react-router-dom/cjs/react-router-dom.min';
import { IonButton, IonButtons, IonContent, IonFab, IonFabButton, IonFabList, IonHeader, IonIcon, IonList, IonMenuButton, IonModal, IonPage, IonTitle, IonToolbar } from '@ionic/react';
import TeamListItem from './TeamListItem';
import { Card } from '@tremor/react';
import { add, personOutline } from 'ionicons/icons';
import { TeamForm } from '../Forms';
import { Col, Row } from 'reactstrap';
import { isUserAnAdmin } from '../../utils';

const mapStateToProps = state => {
    return {
        properties: state.properties,
        team: state.team,
        user: state.user
    };
}

const mapDispatchToProps = {
    fetchTeam,
    fetchUser,
    showLoading,
    deleteTeamMember,
    showCustomError
};

const HOME_PAGE = 'home';
const TEAM_FORM_PAGE = 'teamForm';

class Team extends React.Component{
    constructor(props){
        super(props);
        this.handleSelectTeamMember = this.handleSelectTeamMember.bind(this);
        this.handleCloseTeamForm = this.handleCloseTeamForm.bind(this);
        this.getSelectedTeam = this.getSelectedTeam.bind(this);
        this.state = {
            selectedTeam: this.getSelectedTeam(),
            teamMember: null,
            currentSelectedTeam: [],
            tab: HOME_PAGE,
            teamMemberId: "",
            isAdmin: false
        }
    }

    async fetchInitialData(){
        await Promise.all([
            (
                async () => {
                    if (_.isEmpty(this.props.properties)) {
                        this.props.showLoading(true);
                        await store.dispatch(fetchPropertiesUnitsTenants);
                        this.props.showLoading(false);
                    }
                }
            )(),
            (
                async () => {
                    if (_.isEmpty(this.props.team)) {
                        this.props.showLoading(true);
                        await this.props.fetchTeam();
                        this.props.showLoading(false);
                    }
                }
            )(),
            (
                async () => {
                    if(_.isEmpty(this.props.user)){
                        this.props.showLoading(true);
                        await this.props.fetchUser();
                        this.props.showLoading(false);
                    }
                }
            )()
        ]);
    }

    async componentDidMount(){
        await this.fetchInitialData();
        let selectedTeam = this.getSelectedTeam();
        let currentSelectedTeam = selectedTeam;
        if(!_.isEmpty(this.props.user)){
            let isAdmin = isUserAnAdmin(this.props.user);
            this.setState({isAdmin});
        }

        this.setState({
            selectedTeam,
            currentSelectedTeam
        });
        // Mixpanel.track("Team tab: mounted");
    }

    componentDidUpdate(prevProps, prevState) {
        if (this.props.team !== prevProps.team || this.state.currentPage !== prevState.currentPage ){
            let selectedTeam = this.getSelectedTeam();
            let currentSelectedTeam = selectedTeam;
            this.setState({
                selectedTeam,
                currentSelectedTeam,
            });
        }
      }

    getSelectedTeam(propertyId="", role=""){
        let selectedTeam = Object.values(this.props.team);
        return selectedTeam;
    }


    onClickAddTeam(event){
        event.preventDefault();
        if (!this.state.isAdmin){
            this.props.showCustomError("Only admin users can add team members");
        }else{
            this.setState({tab: TEAM_FORM_PAGE, teamMemberId: "" });
        }
        Mixpanel.track("Team tab: add team btn");

    }

    handleSelectTeamMember(action, teamMemberId){
        let errorMessage = `Only admin users can ${action} team members`;
        if (!this.state.isAdmin){
            this.props.showCustomError(errorMessage);
        }else{
            if(action === 'edit'){
                this.setState({teamMemberId: teamMemberId, tab: TEAM_FORM_PAGE});
                Mixpanel.track("Team tab: edit team member");
            }else if(action === 'delete'){
                if(confirm("Are you sure you want to delete this team member?")){
                    this.props.showLoading(true);
                    this.props.deleteTeamMember(teamMemberId);
                }
                Mixpanel.track("Team tab: delete team member");
            }
        }
    }

    handleCloseTeamForm(){
        this.setState({tab: HOME_PAGE, teamMemberId: "" });
    }

    renderTeamTable(){
        return(
            <React.Fragment>
            <Row className='my-2'>
                <Col xs={6} md={5}>
                    <strong className='ml-2'>Username</strong>
                </Col>
                <Col xs={5} md={6} className=''>
                <strong>Email</strong>
                </Col>
            </Row>
            <Card style={{margin: 0, padding: 0}}>
                <IonList>
                {(this.state.currentSelectedTeam.map((member, index) => {
                    return(
                        <TeamListItem
                            key={member.personId}
                            phoneNumber={member.phoneNumber}
                            username={member.username}
                            email={member.email}
                            firstName={member.firstName}
                            lastName={member.lastName}
                            personId={member.personId}
                            handleTeamMemberAction={this.handleSelectTeamMember.bind(this)}
                            showDetails={false}
                        />
                    )
                }))}
                </IonList>
            </Card>
            </React.Fragment>
        )
    }


    renderHomePage(){
        return (
            <div>
                {this.renderTeamTable()}
            </div>
        );
    }

    renderTeamForm(){
        return (
            <IonModal isOpen={this.state.tab === TEAM_FORM_PAGE} onDidDismiss={this.handleCloseTeamForm}>
                <IonHeader>
                    <IonToolbar>
                        <IonTitle>Team Form</IonTitle>
                        <IonButtons slot="end">
                            <IonButton onClick={this.handleCloseTeamForm}>Close</IonButton>
                        </IonButtons>
                    </IonToolbar>
                </IonHeader>
                <IonContent className="ion-padding">
                    <TeamForm
                        teamMemberId={this.state.teamMemberId}
                    />
                </IonContent>
            </IonModal>
        );
    }

    render(){
        return (
             <IonPage>
                <IonHeader>
                    <IonToolbar>
                        <IonButtons slot="start">
                            <IonMenuButton />
                        </IonButtons>
                        <IonTitle>Team</IonTitle>
                    </IonToolbar>
                </IonHeader>
                <IonContent>

                    {this.state.tab === HOME_PAGE && this.renderHomePage()}
                    {this.state.tab === TEAM_FORM_PAGE && this.renderTeamForm()}

                    <IonFab className='ion-fab' slot="fixed" vertical="bottom" horizontal="end">
                        <IonFabButton aria-label="Actions">
                            <IonIcon icon={add} />
                        </IonFabButton>
                        <IonFabList side="top">
                            <IonFabButton
                                onClick={(event) => this.onClickAddTeam(event)}
                                data-desc="Add New Team Member"
                            >
                                <IonIcon icon={personOutline}></IonIcon>
                            </IonFabButton>
                        </IonFabList>
                    </IonFab>
                </IonContent>
            </IonPage>
        );
    }
}

export default withRouter(connect(
    mapStateToProps,
    mapDispatchToProps
)(Team));